/**
 * This file serves as the component directory
 * The purpose is to uniformly manage externally exported components for easy classification
 */

/**
 * Layout components
 */
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import ContextSwitcher from './RightContent/ContextSwitcher';
import ThemeSwitch from './RightContent/ThemeSwitch';

export {
  AvatarDropdown,
  AvatarName,
  ContextSwitcher,
  Footer,
  Question,
  SelectLang,
  ThemeSwitch,
};
